import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { DEVICES_LIST, SPORTS_PAGE_DATA } from './sportsPageData';

const SportsPage = ({ pageKey }) => {
  const navigate = useNavigate();
  const page = SPORTS_PAGE_DATA[pageKey];

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = `${page.title} - Stream Online | Free Live Sports TV`;
  }, [page]);

  const handleChannelClick = (channel) => {
    navigate(channel.id ? `/live-channels?c=${channel.id}` : '/live-channels');
  };

  const video = typeof page.video === 'string' ? { id: page.video } : page.video;
  const descriptions = page.descriptions || [page.description];

  return (
    <div className="flsStandalonePage sportsPage" style={{ '--sports-background': `url('${page.background}')` }}>
      <section className="flsHeroSection">
        {video && (
          <div className="heroVideoBg">
            <iframe
              src={`https://www.youtube-nocookie.com/embed/${video.id}?autoplay=1&mute=1&controls=0&loop=1&playlist=${video.id}${video.start !== undefined ? `&start=${video.start}` : ''}${video.end !== undefined ? `&end=${video.end}` : ''}&playsinline=1&showinfo=0&rel=0&enablejsapi=1`}
              title={`${page.title} Background Video`}
              frameBorder="0"
              allow="autoplay; encrypted-media; picture-in-picture"
              allowFullScreen
            />
          </div>
        )}
        <div className="heroBgOverlay"></div>
        <div className="heroContentWrapper">
          <h1 className="heroTitle">{page.title}</h1>
          {descriptions.map((description) => <p key={description} className="heroDesc">{description}</p>)}
          <div className="channelsGrid">
            {page.channels.map(([name, buttonText, logo, id]) => {
              const channel = { id, name, buttonText, logo };
              return (
                <div key={name} className="channelCard">
                  <div className="logoContainer">
                    <img src={channel.logo} alt={channel.name} className="channelLogoImg" />
                  </div>
                  <button
                    className="channelCtaBtn"
                    onClick={() => handleChannelClick(channel)}
                    aria-label={channel.buttonText}
                  >
                    {channel.buttonText}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      <section className="howToWatchSection">
        <div className="sectionContainer">
          <h2 className="sectionTitle">How To Watch</h2>
          <div className="devicesGrid">
            {DEVICES_LIST.map((device) => (
              <div key={device.name} className="deviceCard">
                <div className="deviceIconWrapper">
                  <img src={device.icon} alt="" />
                </div>
                <span className="deviceName">{device.name}</span>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default SportsPage;
